<template>
  <div class="home main-content">
    <MainHeader :navName="'订货'"></MainHeader>
    <div class="content">
      <div class="btns">
        <Button class="btns-item"  icon="ios-print" type="primary" @click="onPrint">打印</Button>
        <Button class="btns-item"  icon="md-mail" type="primary" :loading="options.sendMailLoading" @click="onSendMail">
          <span v-if="!options.sendMailLoading">发送邮箱</span>
          <span v-else>发送中</span>
        </Button>
        <Button class="btns-item"  icon="md-time" type="warning" @click="modals.scheduleMode = true">时间表</Button>
      </div>
      <div class="tip">
        <div class="tip-title">
          {{database.info.title}}
        </div>
        <div class="tip-time" v-if="curProgress == 1">
          <span>申请订货结束时间</span>
          <div class="tip-time-num">{{database.info.place_order_end_time | unixToDate('YYYY-MM-DD HH:mm')}}</div>
        </div>
        <div class="tip-time" v-if="curProgress == 2">
          <span>确认订货结束时间</span>
          <div class="tip-time-num">{{database.info.order_confirmation_end_time | unixToDate('YYYY-MM-DD HH:mm')}}</div>
        </div>
        <div class="tip-time">
          当前系统时间
          <div class="tip-time-num">{{curSysTime | unixToDate('YYYY-MM-DD HH:mm')}}</div>
        </div>
      </div>
      <div class="btn2s">
        <div class="btn2s-item" v-if="curProgress!= 3"> <img class="icon-right" src="../assets/images/icon-right.png">
          <span v-if="curProgress == 1">申请订货</span>
          <span v-if="curProgress == 2">确认订货</span>
        </div>
        <div class="btn2s-item" v-if="curProgress!= 3">剩余时间: <span style="font-weight: bold">{{timeLeft.d}}:{{timeLeft.h}}:{{timeLeft.m}}:{{timeLeft.s}}</span></div>
        <div class="btn2s-item">
          <span v-if="database.info.count > 0"><Icon size="20" class="text-success" style="font-weight: bold; margin-right: 10px" type="md-checkmark" />已订：{{database.info.count}}</span>
          <span v-else>未订货</span>
        </div>
        <div class="btn2s-item">总共：{{database.info.all_weight || 0}}Ct</div>
      </div>
      <div class="screen box-border">
        <div class="screen-box">
          <ButtonGroup >
            <Button :type="database.curSize.id == '' ? 'primary': 'default'" @click="onSwitchSize({id: '', size: 'All Sizes'})">All Sizes</Button>
            <Button :type="database.curSize.id == item.id ? 'primary': 'default'" v-if="database.sizeList.length > 0"
                    v-for="(item, index) in database.sizeList"
                    :key="index"
                    @click="onSwitchSize(item)"
            >{{item.size}}</Button>
          </ButtonGroup>
        </div>
        <Button class="screen-myOrder" :type="database.curSize.id == 'myOrder' ? 'primary': 'default'" @click="onSwitchSize({id: 'myOrder', size: '我的订单'})">MY Order</Button>
      </div>
      <div class="address box-border" v-if="database.addressList && database.addressList.length > 0 && database.addressList[0].name">
        <div class="address-box">
          <ButtonGroup >
            <Button :type="database.curAddress.id === item.id ? 'error': 'default'"  v-for="(item, index) in database.addressList" :key="index" @click="onSwitchAddress(item)">{{item.name}}</Button>
          </ButtonGroup>
        </div>
      </div>
      <div class="miningArea" :class="minignColor">
        <div class="miningArea-list" v-if="database.curAddress && database.curAddress.children">
          <div class="miningArea-item" :class="'color'+ (index + 1)% 5" v-for="(item, index) in database.curAddress.children"
               :key="index"
               @click="onSwitchMinign(item, index)"
          >{{item.name}}</div>
        </div>
        <div class="miningArea-info">
          <div class="miningArea-info-left">
            {{database.curMining.name}} ({{database.curSize.size}})
          </div>
          <div class="miningArea-info-right">
            小计: <span style="font-weight: bold;">{{selectList.total || 0 | NumFormat}}</span> Ct
          </div>
        </div>
      </div>
      <div class="table">
        <section v-if="curProgress == 0 || curProgress == 1">
          <table  style="width: 100%;">
            <tr class="tab-title">
              <th>编号</th>
              <th>已选</th>
              <th>大小</th>
              <th>类型</th>
              <th>价格范围 <br>$/Ct</th>
              <th>标准箱重 <br>Ct</th>
              <th>订单重量 <br>Ct</th>
              <th v-if="!timeLeft.isEnd"></th>
              <th v-if="!timeLeft.isEnd">订单状态 </th>
            </tr>
            <tr class="tab-list" v-if="dataList && dataList.length > 0"
                v-for="(item, index) in dataList" :key="index">
              <td>{{item.article}}</td>
              <td>
                <Checkbox class="checkbox" v-model="item.checkbox" disabled size="large"></Checkbox>
              </td>
              <td>
                {{item.size}}
              </td>
              <td>{{item.form}}</td>
              <td>{{item.price_range}}</td>
              <td>{{item.standard_box_weight}}</td>
              <td style="width: 80px" :style="item.auction == 1 || item.auction == 2? 'background: #edfff3;': ''">
                <Input style="width: 100%" v-if="item.auction == 0 && !timeLeft.isEnd" :min="0" v-model="item.weight"></Input>
                <span v-if="item.auction == 1 || item.auction == 2">{{item.weight || '---'}}</span>
              </td>
              <td v-if="!timeLeft.isEnd">
                <Button v-if="item.auction == 0"  type="success" @click="onAuction(index)">
                  <span v-if="curProgress == 1">申请订货</span>
                  <span v-if="curProgress == 2">确认订货</span>
                </Button>
                <span v-if="item.auction  == 1" class="text-primary" style="cursor: pointer" @click="onCancelAuction(index)">删除订单</span>
              </td>
              <td v-if="!timeLeft.isEnd">
                <span v-if="item.auction == 0">未下单</span>
                <span v-if="item.auction == 1" class="text-success">已下单</span>
                <span v-if="item.auction == 2" class="text-success">待确认</span>
              </td>
            </tr>
            <tr v-if="!dataList || dataList.length <= 0">
              <td  colspan="11">暂无数据~</td>
            </tr>
          </table>
        </section>
        <section  v-if="curProgress == 2">
          <table  style="width: 100%;">
            <tr class="tab-title">
              <th>编号</th>
              <th>已选</th>
              <th>大小</th>
              <th>类型</th>
              <th>订单重量 <br>Ct</th>
              <th></th>
              <th>订单状态 </th>
            </tr>
            <tr class="tab-list" v-if="dataList && dataList.length > 0 && item.auction >= 2"
                v-for="(item, index) in dataList" :key="index">
              <td>{{item.article}}</td>
              <td>
                <Checkbox class="checkbox" v-model="item.checkbox" disabled size="large"></Checkbox>
              </td>
              <td>
                {{item.size}}
              </td>
              <td>{{item.form}}</td>
              <td style="width: 80px;background: #edfff3">
                <span>{{item.weight || '---'}}</span>
              </td>
              <td >
                <Button v-if="item.auction == 4"  type="success" @click="onAuction(index)">
                  <span >确认订单</span>
                </Button>
                <span v-if="item.auction  == 2" class="text-primary" style="cursor: pointer" @click="onCancelAuction(index)">删除订单</span>
              </td>
              <td>
                <span v-if="item.auction == 4" >已取消</span>
                <span v-if="item.auction == 2" class="text-success">已下单</span>
                <span v-if="item.auction == 3" class="text-success">已确认</span>
              </td>
            </tr>
            <tr v-if="!dataList || dataList.length <= 0">
              <td  colspan="11">暂无数据~</td>
            </tr>
          </table>
        </section>
        <section v-if="curProgress === 3">
          <table  style="width: 100%;">
            <tr class="tab-title">
              <th>编号</th>
              <th>已选</th>
              <th>大小</th>
              <th>类型</th>
              <th>价格范围 <br>$/Ct</th>
              <th>标准箱重 <br>Ct</th>
              <th>订单重量 <br>Ct</th>
            </tr>
            <tr class="tab-list" v-if="dataList && dataList.length > 0"
                v-for="(item, index) in dataList" :key="index">
              <td>{{item.article}}</td>
              <td>
                <Checkbox class="checkbox" v-model="item.checkbox" disabled size="large"></Checkbox>
              </td>
              <td>
                {{item.size}}
              </td>
              <td>{{item.form}}</td>
              <td>{{item.price_range}}</td>
              <td>{{item.standard_box_weight}}</td>
              <td style="width: 80px" :style="item.auction == 3? 'background: #edfff3;': ''">
                <span v-if="item.auction == 3">{{item.weight || '-'}}</span>
                <span v-else>-</span>
              </td>
            </tr>
            <tr v-if="!dataList || dataList.length <= 0">
              <td  colspan="11">暂无数据~</td>
            </tr>
          </table>
        </section>
      </div>
      <MainFooter></MainFooter>
    </div>
    <Modal v-model="modals.registrationModal" class-name="vertical-center-modal" @on-ok="onRegistration">
      <p>确认我愿意参加由上市股份公司雅罗莎举办的这次拍卖会?</p>
    </Modal>
    <Modal v-model="modals.scheduleMode" width="300"
           class-name="schedule-modal"
           footer-hide>
      <p slot="header" style="color:#fff;text-align:center; font-weight: bold;">
        <span>时间表</span>
      </p>
      <div style="text-align:center">
<!--        <div class="schedule-item">-->
<!--          <div class="schedule-item-name">开始时间</div>-->
<!--          <div class="schedule-item-value">{{database.info.create_time | unixToDate('YYYY-MM-DD HH:mm')}}</div>-->
<!--        </div>-->
        <div class="schedule-item" :class="curProgress == 1? 'cur': ''">
          <div class="schedule-item-name">订货申请时间</div>
          <div class="schedule-item-value">{{database.info.place_order_start_time | unixToDate('MM月DD日 HH:mm')}} - {{database.info.place_order_end_time | unixToDate('MM月DD日 HH:mm')}}</div>
          <div class="schedule-success" v-if="curProgress > 1">
            <Icon type="md-checkmark-circle-outline" style="font-weight: bold" />
          </div>
        </div>
        <div class="schedule-item" :class="curProgress == 2? 'cur': ''">
          <div class="schedule-item-name">订货确认时间</div>
          <div class="schedule-item-value">{{database.info.order_confirmation_start_time | unixToDate('MM月DD日 HH:mm')}} - {{database.info.order_confirmation_end_time | unixToDate('MM月DD日 HH:mm')}}</div>
          <div class="schedule-success" v-if="curProgress > 2">
            <Icon type="md-checkmark-circle-outline" style="font-weight: bold" />
          </div>
        </div>
        <div class="schedule-item ">
          <div class="schedule-item-name">结束</div>
          <div class="schedule-item-value">{{database.info.end_time | unixToDate('MM月DD日 HH:mm')}}</div>
          <div class="schedule-success" v-if="curProgress == 3">
            <Icon type="md-checkmark-circle-outline" style="font-weight: bold" />
          </div>
        </div>
      </div>
    </Modal>
    <Modal v-model="modals.viewMode" class-name="vertical-center-modal">
      <p style="font-size: 16px">你要看<span style="color: #2d8cf0">第{{modals.viewModeIndex + 1}}批</span>石头吗？</p>
    </Modal>
    <Modal v-model="modals.downloadScanMode" class-name="vertical-center-modal">
      <p style="text-align: center; margin-top: 10px">确定下载 <span style="color: #2d8cf0">第{{modals.viewModeIndex + 1}}批石头</span>的数码扫描？</p>
      <div style="text-align: center;margin-top: 20px">
        <Button style="margin: 0 10px" @click="modals.downloadScanMode = false">取消</Button>
        <Button style="margin: 0 10px" type="success" icon="md-cloud-download">下载</Button>
      </div>
      <div slot="footer">
        <p style="text-align: center">*请注意,此处提供的 Sarine galax扫描和Zvi yehuda测色仪是由 Sarine技术有限公司在其在莫斯科的认可实验室中创建的。</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import MainHeader from '../public/MainHeader'
import MainFooter from '../public/MainFooter'
import Core from '@/until/core'
import moment from 'moment'

export default {
  name: 'ListOrder',
  data () {
    return {
      curSysTime: '',
      timeLeft: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
        isEnd: false
      },
      modals: {
        registrationModal: false,
        scheduleMode: false,
        viewMode: false,
        viewModeText: '',
        viewModeIndex: 0,
        downloadScanMode: false
      },
      options: {
        type: 1,
        sendMailLoading: false
      },
      database: {
        id: '',
        list: [],
        info: {},
        sizeList: [],
        addressList: [],
        curSize: {id: '', size: 'All Sizes'},
        curAddress: {},
        curMining: {},
        myOrder: [],
        myCar: [],
        paging: {
          totalrecord: 0,
          totalpage: 0,
          currentpage: 0,
          pagesize: 999,
          pageint: 1
        }
      },
      curProgress: 0 // 活动进行到第几阶段
    }
  },
  computed: {
    // timeLeft () {
    //   const result = {
    //     d: 0,
    //     h: 0,
    //     m: 0
    //   }
    //   const endTime = this.database.info.end_time || 0
    //   const rTime = parseInt(endTime) - (Date.now() / 1000)
    //   result.d = Math.floor(rTime / 86400)
    //   result.h = Math.floor((rTime - 86400 * result.d) / 3600)
    //   result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
    //   return result
    // },
    minignColor () {
      const data = this.database.curAddress.children || []
      let result = ''
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === this.database.curMining.id) {
          result = 'activeColor' + (i + 1) % 5
          break
        }
      }
      return result
    },
    dataList () {
      const data = this.database.list || []
      const result = []
      const boo = this.database.curSize.id === 'myOrder'
      for (const item of data) {
        item.checkbox = true
        if (parseInt(item.auction) === 0) {
          item.checkbox = false
        }
        if (boo) {
          if (parseInt(item.auction) !== 0) {
            result.push(item)
          }
        } else {
          result.push(item)
        }
      }
      return result
    },
    selectList () {
      const data = this.database.list
      const prize = {
        num: 0,
        total: 0
      }
      if (this.curProgress === 1 || this.curProgress === 0) {
        for (const item of data) {
          if (parseInt(item.auction) === 1 || parseInt(item.auction) === 2) {
            prize.num += 1
            prize.total += parseFloat(item.weight)
          }
        }
      } else if (this.curProgress === 2) {
        for (const item of data) {
          if (parseInt(item.auction) === 2 || parseInt(item.auction) === 3) {
            prize.num += 1
            prize.total += parseFloat(item.weight)
          }
        }
      } else if (this.curProgress === 3) {
        for (const item of data) {
          if (parseInt(item.auction) === 3) {
            prize.num += 1
            prize.total += parseFloat(item.weight)
          }
        }
      }
      return prize
    },
    orderList () {
      const data = this.database.myOrder
      return data
    },
    carList () {
      const data = this.database.myCar
      for (const item of data) {
        if (typeof item.cart_attribute === 'string') {
          try {
            item.cartAttribute = JSON.parse(item.cart_attribute)
          } catch (e) {
            item.cartAttribute = {}
          }
        } else {
          item.cartAttribute = item.cart_attribute
        }
      }
      return data
    },
    tabBottomStyle () {
      if (this.options.type === 1) {
        return 'background: rgb(178, 164, 211)'
      } else if (this.options.type === 2) {
        return 'background: rgb(110, 193, 174)'
      } else if (this.options.type === 3) {
        return 'background: rgb(216, 237, 244)'
      }
    }
  },
  methods: {
    onShowSchedule (type) {
      if (type) {
        this.modals.scheduleMode = true
      }
      const cTime = new Date().getTime() / 1000
      if (cTime < parseInt(this.database.info.place_order_start_time)) {
        // 未开始
        this.curProgress = 0
      } else if (cTime >= parseInt(this.database.info.place_order_start_time) && cTime < parseInt(this.database.info.place_order_end_time)) {
        // 申请订货
        this.curProgress = 1
      } else if (cTime >= parseInt(this.database.info.order_confirmation_start_time) && cTime < parseInt(this.database.info.order_confirmation_end_time)) {
        // 确认订货
        this.curProgress = 2
      } else if (cTime >= parseInt(this.database.info.order_confirmation_end_time)) {
        // 已经结束
        this.curProgress = 3
      }
      this.getList()
      // 计算倒计时
      this.runCountTime()
    },
    onSendMail () {
      this.options.sendMailLoading = true
      let url = ''
      if (this.curProgress === 1) {
        url = '/Auction/Order/CartCreate'
      } else if (this.curProgress === 2) {
        url = '/Auction/Order/ConfirmOrder'
      }
      if (!url) {
        return false
      }
      const param = {}
      param.activity_id = this.database.id
      Core(url, param).then(res => {
        if (res.error_code && !res.data) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Message.success('邮件发送成功')
        this.getDetail(() => {
          this.onShowSchedule()
        })
      }).finally(() => {
        this.options.sendMailLoading = false
      })
    },
    runCountTime () {
      // 获取当前时间
      let date = new Date()
      let now = date.getTime()
      // 设置截止时间
      let end
      if (this.curProgress === 1) {
        end = parseInt(this.database.info.place_order_end_time) * 1000
      }
      if (this.curProgress === 2) {
        end = parseInt(this.database.info.order_confirmation_end_time) * 1000
      }
      // end = '1583824750000'
      // 时间差
      let leftTime = end - now
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.timeLeft.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        // 时
        let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.timeLeft.h = h < 10 ? '0' + h : h
        // 分
        let m = Math.floor(leftTime / 1000 / 60 % 60)
        this.timeLeft.m = m < 10 ? '0' + m : m
        // 秒
        let s = Math.floor(leftTime / 1000 % 60)
        this.timeLeft.s = s < 10 ? '0' + s : s
      } else {
        this.timeLeft.d = 0
        this.timeLeft.h = '00'
        this.timeLeft.m = '00'
        this.timeLeft.s = '00'
      }
      // 等于0的时候不调用
      if (Number(this.timeLeft.d) === 0 && Number(this.timeLeft.h) === 0 && Number(this.timeLeft.m) === 0 && Number(this.timeLeft.s) === 0) {
        if (this.curProgress !== 3) { // 活动还未结束，刷新数据
          location.reload()
          return false
        }
        this.timeLeft.isEnd = true
        return false
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.runCountTime, 1000)
      }
    },
    runSysTime () {
      this.curSysTime = new Date().getTime() / 1000
      setInterval(() => {
        this.curSysTime = new Date().getTime() / 1000
      }, 1000)
    },
    onSwitchSize (item) {
      this.database.curSize = item
      this.getList()
    },
    // 切换看货地址
    onSwitchAddress (item) {
      this.database.curAddress = item
      if (this.database.curAddress.children && this.database.curAddress.children.length > 0) {
        this.database.curMining = this.database.curAddress.children[0]
      } else {
        this.database.curMining = []
      }
      this.getList()
    },
    // 切换矿区
    onSwitchMinign (item) {
      this.database.curMining = item
      this.getList()
    },
    getSizeList () {
      const param = this.database.paging
      param.activity_id = this.database.id
      Core('/Auction/AuctionActivity/SizeList', param).then(res => {
        if (res.data && res.data.list) {
          this.database.sizeList = res.data.list
        }
      })
    },
    getAddressList (callback) {
      const param = this.database.paging
      param.activity_id = this.database.id
      Core('/Auction/AuctionActivity/companyLists', param).then(res => {
        if (res.data && res.data.list) {
          this.database.addressList = res.data.list
          if (this.database.addressList && this.database.addressList.length > 0) {
            this.database.curAddress = this.database.addressList[0]
            if (this.database.curAddress && this.database.curAddress.children) {
              this.database.curMining = this.database.curAddress.children[0]
            }
          }
        }
      }).finally(() => {
        callback && callback()
      })
    },
    onShowViewModal (type, index) {
      this.modals.viewModeIndex = index
      if (type === 'request') {
        this.modals.viewMode = true
      } else if (type === 'download') {
        this.modals.downloadScanMode = true
      }
    },
    onPrint () {
      window.print()
    },
    // 参与拍卖
    onRegistration () {
      this.modals.registrationModal = false
      this.$Message.success('登记成功！')
    },
    onCancelAuction (index) {
      if (index < 0 || index > this.database.list.length - 1) { return }
      const data = this.database.list[index]
      if (this.curProgress === 1) {
        const param = {}
        param.weight = data.weight
        param.activity_id = this.database.id
        param.diamond_package_id = data.id
        param.cart_product_number = -1
        Core('/Auction/Cart/Changes', {database: param}).then(res => {
          if (res.error_code && !res.data) {
            return this.$Message.error(res.error_msg || '系统繁忙！')
          }
          this.$Message.success('操作成功！')
          this.getDetail(() => {
            this.onShowSchedule()
          })
        })
      } else if (this.curProgress === 2) {
        const param = {}
        param.cart_id = [data.id]
        param.package_id = this.database.id
        Core('/Auction/Order/DelecteCart', param).then(res => {
          if (res.error_code && !res.data) {
            return this.$Message.error(res.error_msg || '系统繁忙！')
          }
          this.$Message.success('操作成功！')
          this.getDetail(() => {
            this.onShowSchedule()
          })
        })
      }
    },
    onAuction (index) {
      if (index < 0 || index > this.database.list.length - 1) { return }
      const data = this.database.list[index]
      if (this.curProgress === 1) {
        // 申请订货
        const w = parseInt(data.weight)
        const bw = parseInt(data.standard_box_weight)
        if (w < bw) {
          return this.$Message.error('至少订货一箱')
        }
        if (w % bw !== 0) {
          return this.$Message.error('订单重量不合法！')
        }
        const param = {}
        param.weight = w
        param.activity_id = this.database.id
        param.diamond_package_id = data.id
        param.cart_product_number = 1
        Core('/Auction/Cart/Changes', {database: param}).then(res => {
          if (res.error_code && !res.data) {
            return this.$Message.error(res.error_msg || '系统繁忙！')
          }
          this.$Message.success('操作成功！')
          this.getDetail(() => {
            this.onShowSchedule()
          })
        })
      } else if (this.curProgress === 2) {
        // 确定订货
        const param = {}
        param.cart_id = [data.id]
        param.activity_id = this.database.id
        Core('/Auction/Order/ConfirmOrder', param).then(res => {
          if (res.error_code && !res.data) {
            return this.$Message.error(res.error_msg || '系统繁忙！')
          }
          this.$Message.success('操作成功！')
          this.getDetail(() => {
            this.onShowSchedule()
          })
        })
      }
    },
    onPlace (item) {
      const cartId = []
      cartId.push(item.id)
      Core('/Auction/Order/CartCreate', {cart_id: cartId}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Modal.success({
          // title: title,
          content: '订单提交成功'
        })
      })
    },
    onPushCar (item) {
      const database = {
        activity_id: item.id,
        weight: item.weight
      }
      Core('/Auction/Cart/Change', {database}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '加入购物车失败！')
        }
        this.$Message.success('加入购物车成功')
      })
    },
    getMyCart () {
      Core('/Auction/Cart/Listing').then(res => {
        if (res.data && res.data.list) {
          this.database.myCar = res.data.list
        }
      })
    },
    getMyOrder () {
      Core('/Auction/Order/ManagerListing').then(res => {
        if (res.data && res.data.list) {
          this.database.myOrder = res.data.list
        }
      })
    },
    getDetail (callback) {
      const param = {}
      param.activity_id = this.database.id
      Core('/Auction/AuctionActivity/GetOne', param).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        if (res.data) {
          this.database.info = res.data
          callback && callback()
        }
      })
    },
    getList () {
      const param = this.database.paging
      param.activity_id = this.database.id
      if (this.database.curSize.id === 'myOrder') {
        param.size_id = ''
      } else {
        param.size_id = this.database.curSize.id || ''
      }
      param.company_id1 = this.database.curAddress.id
      param.company_id2 = this.database.curMining.id
      let url = '/Auction/AuctionActivity/DiamondPackages'
      // if (this.curProgress === 1) {
      //   url = '/Auction/AuctionActivity/DiamondPackages'
      // } else if (this.curProgress === 2) {
      //   url = '/Auction/Cart/CartListings'
      // }
      Core(url, param).then(res => {
        if (res.data && res.data.list) {
          this.database.list = res.data.list
        }
      })
    }
  },
  filters: {
    unixToDate (unix, format, defValue) {
      if (/\d{13}/.test(unix)) {
        unix = parseInt(unix / 1000, 10)
      }
      let date = moment(/\d{10}/.test(unix) ? moment.unix(unix) : '').format(format || 'YYYY-MM-DD HH:mm:ss')
      return date === 'Invalid date' ? (defValue || '---') : date
    },
    NumFormat (value) {
      if (!value) return '0'
      value = value.toFixed(2)
      var intPart = Number(value).toFixed(0) // 获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1 ') // 将整数部分逢三一断
      var floatPart = '' // 预定义小数部分
      var value2Array = value.split('.')
      // =2表示数据有小数位
      if (value2Array.length === 2) {
        // floatPart = value2Array[1].toString() // 拿到小数部分
        // if (floatPart.length === 1) { // 补0,实际上用不着
        //   return intPartFormat + '.' + floatPart + '0'
        // } else {
        //   return intPartFormat + '.' + floatPart
        // }
        return intPartFormat
      } else {
        return intPartFormat + floatPart
      }
    }
  },
  components: {
    MainHeader,
    MainFooter
  },
  mounted () {
    this.database.id = this.$route.query.id
    // this.getMyOrder()
    this.runSysTime()
    this.getAddressList(() => {
    })
    this.getDetail(() => {
      this.onShowSchedule()
    })
    this.getSizeList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  >>> .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal{
    top: 0;
  }
  >>> .schedule-modal .ivu-modal-body{padding: 0 5px}
  >>> .schedule-modal .ivu-modal-header{background: #ff9900; border-radius: 6px 6px 0 0;color: #fff}

  .checkbox >>> .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {animation-name: none;border-color: #fff;
  }
  .checkbox >>> .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner {border-color: #2d8cf0;background-color: #2d8cf0;}
  .schedule-item{text-align: left; border-bottom: 1px dotted rgb(137, 108, 57); padding: 10px 10px; position: relative}
  .schedule-item:last-child{border: none}
  .schedule-item-name{color: rgb(137, 108, 57); font-size: 16px; font-weight: bold}
  .schedule-item.cur{background: rgb(252, 248, 227)}
  .schedule-success{position: absolute; font-size: 20px;font-weight: bold; right: 10px; top: 30%; color: #378248}
  .content{width: 100%; min-width: 800px; max-width: 1200px; padding: 30px 0; margin: 0 auto}
  .tab{width: 100%; font-size: 16px; display: flex}
  .tab-item{background: rgb(178, 164, 211); width: 230px; line-height: 40px; font-weight: bold; text-align: center; margin-right: 10px;
  border-radius: 5px 5px 0 0; color: #fff;border: 1px solid #7d7d7d; border-bottom: none; cursor: pointer }
  .tab-bottom{width: 100%; height: 30px;}
  .tab-item-type1{background: rgb(178, 164, 211); color: rgb(91, 59, 166)}
  .tab-item-type2{background: rgb(110, 193, 174); color: rgb(45, 109, 82)}
  .tab-item-type3{background: rgb(216, 237, 244); color: rgb(59, 95, 133)}
  .tab-item.active{border-color: rgba(0, 0, 0, 0); color: #fff}
  .tab-total{width: 100%; line-height: 30px; padding: 0 20px; text-align: right}

  .tip{background: rgb(239, 240, 242); border: 1px solid rgb(223, 235, 237); display: flex; color: #787c7e; padding:10px 20px;
  border-radius: 5px; margin: 30px 0; font-size: 16px;color: rgb(40, 110, 141)}
  .tip-title{width: 260px; font-weight: bold;}
  .tip-time{flex: 1}
  .tip-time .tip-time-num{font-weight: bold;}

  .icon-search{width: 28px; height: 28px; background: rgb(245, 201, 140); border-radius: 5px; margin-left: 20px }
  .icon-dui{font-size: 20px;}

  .box-border{background: rgb(239, 240, 242); border: 1px solid rgb(223, 235, 237);  color: #787c7e; padding:15px 20px;
    border-radius: 5px; margin: 30px 0;}
  .screen{overflow: hidden; display: flex;}
  .screen-box{ flex: 1}
  .screen >>> .ivu-btn{ height: 38px;}

  .address >>> .ivu-btn{ height: 38px;}

  .miningArea{}
  .miningArea-list{display: flex}
  .miningArea-item{min-width: 290px; margin-right: 10px; line-height: 45px; font-size: 16px; font-weight: bold; text-align: center; cursor: pointer; border-radius: 5px 5px 0 0}
  .miningArea .color1{background: #f0faff; border: 1px solid #abdcff;border-bottom: none; color: #abdcff}
  .miningArea .color2{background: #edfff3; border: 1px solid #8ce6b0;border-bottom: none; color: #8ce6b0}
  .miningArea .color3{background: #fff9e6; border: 1px solid #ffd77a;border-bottom: none; color: #ffd77a}
  .miningArea .color4{background: #ffefe6; border: 1px solid #ffb08f;border-bottom: none; color: #ffb08f}
  .miningArea.activeColor1 .miningArea-info{background: #abdcff}
  .miningArea.activeColor1 .miningArea-item:nth-child(1){background: #abdcff; color: #fff}
  .miningArea.activeColor2 .miningArea-info{background: #8ce6b0}
  .miningArea.activeColor2 .miningArea-item:nth-child(2){background: #8ce6b0; color: #fff}
  .miningArea.activeColor3 .miningArea-info{background: #ffd77a}
  .miningArea.activeColor3 .miningArea-item:nth-child(3){background: #ffd77a; color: #fff}
  .miningArea.activeColor4 .miningArea-info{background: #ffb08f}
  .miningArea.activeColor4 .miningArea-item:nth-child(4){background: #ffb08f; color: #fff}
  .miningArea-info{line-height: 45px; overflow:hidden; font-size: 16px;padding: 0 20px; color: #000}
  .miningArea-info .miningArea-info-left{float: left}
  .miningArea-info .miningArea-info-right{float: right}

  .btn2s{display: flex; margin-bottom: 30px;}
  .btn2s-item{border: 1px solid #2d8cf0; flex: 1;  line-height: 45px; text-align: center; margin: 0 20px; border-radius: 5px; cursor: pointer}
  .btn2s-item:last-child{margin-right: 0}
  .btn2s-item:first-child{margin-left: 0}
  .btn2s-item .icon-right{width: 13px; height: 13px; margin-top: 10px; margin-right: 10px}

  .registration{width: 100%; border-radius: 5px;border: 1px solid #ffb08f; overflow: hidden}
  .registration-title{background-color: rgb(240, 222, 222); color: rgb(170, 68, 67); font-size: 16px; line-height: 55px; padding-left: 15px; border-bottom: 1px solid #ffb08f}
  .registration-content{line-height: 50px; padding-left: 15px;}
  .registration-btn{background: #eff0f2; line-height: 55px; text-align: right; padding: 0 15px; border-top: 1px solid #cccccc}
  /*.registration-btn-item{float: right;}*/
  table {
    width: 90%;
    background: #ccc;
    margin: 0 auto;
    border-collapse: collapse;/*border-collapse:collapse合并内外边距(去除表格单元格默认的2个像素内外边距*/
  }
  th,td {
    /*height: 25px;*/
    /*line-height: 50px;*/
    padding: 10px 0;
    text-align: center;
    /*border: 1px solid #ccc;*/
  }
  .tab-title{border: 1px solid #ccc;}
  .tab-list{border: 1px solid #ccc; border-top: none}
  th {
    background: #f8f8f9;
    font-weight: normal;
  }
  tr {
    background: #fff;
  }
  /*tr:hover {*/
    /*background: #cc0;*/
  /*}*/
  td a {
    color: #06f;
    text-decoration: none;
  }
  .btns{ overflow: hidden}
  .btns-item{float: right; margin-left: 20px;}
</style>



// WEBPACK FOOTER //
// src/components/ListOrder.vue